/* =============================================================================
DB:       Realtime DB
PATH:     user.{userId}.sequence_settings.{goalId}
PURPOSE:  User sequence for a goal
============================================================================= */
import moment from '@/moment-gp'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},
  schema: {
    create({ cachedName }, data) {
      let settings = {
        cachedName: cachedName,
        sortidx:    data.sortidx || 1,
      };
      if ( data.sender ) {
        Object.assign(settings, {
          invitedAt:        moment.currentTimeServer('REALTIMEDB'),
          senderId:         data.sender.uid,
          cachedSenderName: data.sender.name,
          cachedProfilePic: data.sender.url
        })
      }
      return settings;
    },

    fields: {
      cachedName: {},
      sortidx: {},
      invitedAt: { validate_bolt_type: 'Timestamp' },
      senderId: {},
      cachedSenderName: {},
      cachedProfilePic: {},
    }
  }
};
